var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { $modal } from 'ziphy-web-shared/basic/lib/utilities/modals';
import { VerifyResultsModal } from '@core/src/nedoShared/features/chat/components/modals/VerifyResultsModal/VerifyResultsModal';
import { copyLink, showCopyNotification } from '@core/src/nedoShared/features/chat/utils/copyLink';
export const useOrderItemDropdown = ({ order }) => {
    const { t } = useTranslation();
    // TODO: change consultation date
    const handleChangeConsultationDate = useCallback(() => __awaiter(void 0, void 0, void 0, function* () { }), []);
    const handleCopyOrderId = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const success = yield copyLink(order.number);
            if (success) {
                showCopyNotification(t('label.order_id_copied'));
            }
            else {
                alert(t('label.error_copying_link'));
            }
        }
        catch (error) {
            console.error('Error changing OrderID', error);
            alert(t('label.error_copying_link'));
        }
    }), []);
    const submitCancelOrder = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        // TODO
        console.log('cancel order');
    }), []);
    const handleCancelOrder = useCallback(() => {
        $modal.add(VerifyResultsModal, {
            data: {
                title: t('label.cancel_order'),
                message: t('label.cancel_order_message'),
            },
            type: 'cancel',
            submitButtonText: t('btn.cancel_order'),
            cancelButtonText: t('btn.cancel'),
            onDone: submitCancelOrder,
        });
    }, []);
    return {
        handleChangeConsultationDate,
        handleCopyOrderId,
        handleCancelOrder,
    };
};
